// extracted by mini-css-extract-plugin
module.exports = {"favorite":"styles_favorite__1K52B"};